function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
	}
	return "";
}

const popupSnippet = document.querySelector(".Snippet.Popup");
if (popupSnippet) {
	let cookie = getCookie("popup");
	if (cookie === "") {
		if (popupSnippet.classList.contains("hidden")) {
			popupSnippet.classList.remove("hidden");
		}
		popupSnippet.classList.add("visible");
	}

	const close = popupSnippet.querySelector("span.close");
	close.addEventListener("click", function() {
		setCookie('popup','hidden', 1);
		if (popupSnippet.classList.contains("visible")) {
			popupSnippet.classList.remove("visible");
		}
		popupSnippet.classList.add("hidden");
	});

	const link = popupSnippet.querySelector("a.more");
	link.addEventListener("click", function() {
		setCookie('popup','hidden', 1);
		if (popupSnippet.classList.contains("visible")) {
			popupSnippet.classList.remove("visible");
		}
		popupSnippet.classList.add("hidden");
	});
}